module.exports = __webpack_public_path__ + "static/media/slider5.2443a6e8.png";